export default __webpack_public_path__ + "images/b4c8fd76e3c7fbfcf92f4a5243fd6049.svg";